module.exports = __webpack_public_path__ + "img/home_web_06.63326317.png";